import { render } from "./BaseCard.vue?vue&type=template&id=1fcd6aca&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=1fcd6aca&scoped=true&lang=css"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcd6aca"]])

export default __exports__